@if (category$ | async; as category) {
  <div class="bg-white border m-2 py-3 px-3 shadow-sm">
    <h5>{{ displayLabel$ | async }}</h5>
    @if (category === 'None') {
      <p class="mb-2">
        <span class="text-danger">Warning:</span> Marking a device as unavailable will take it out of single app mode,
        so it
        can be diagnosed. Make sure the device is not in a guest room. <br />
        This action should only be performed when the device is malfunctioning.
      </p>
    }
    @if (category === 'Brand') {
      <p class="mb-2">
        <span class="text-warning text-bold">Remark:</span> when the device is unassigned all location and room based
        settings will be removed. The device should not be in an room anymore.
      </p>
    }
    @if (category === 'Location' && !(selection$ | async)?.roomId) {
      <div class="mb-2">
        <span class="text-danger">Warning:</span> Marking this device as spare will remove the ability to control the
        room
        with the app and will show the setup app. When doing this the device should not be in a room anymore.
      </div>
    }
    @if (showSelector$ | async) {
      <era-device-link-selector [selection]="selection$ | async"
                                [isSpare]="category === 'Location'"
                                [isBar]="category === 'Bar'"
                                [isFrontDesk]="category === 'FrontDesk'"
                                [isHousekeeping]="category === 'Housekeeping'"
                                [isKiosk]="category === 'Kiosk'"
                                [isStaff]="category === 'Staff'"
                                (selectionChange)="updateSelection($event)">
      </era-device-link-selector>
    }
    <button type="submit"
            [class]="submitButtonClass$ | async"
            [id]="category === 'Room' ? 'device-assign-assign-button' : null"
            (click)="markAsCategory()">{{ submitButtonLabel$ | async }}</button>
    <a type="cancel"
       class="btn btn-outline-primary"
       [id]="category === 'Room' ? 'device-assign-cancel-button' : null"
       [routerLink]="['../']">Cancel</a>
  </div>
}